import React, { useContext, useReducer } from 'react';
import generateId from "../../util/generateId";

const ModalContext = React.createContext();

const initialState = [];
const reducer = (state, action) => {
    if (typeof action === 'string') {
        return [...state].filter((modal) => {
            return modal.id !== action;
        });
    }

    return [...state, { modal: action, id: generateId() }];
};

export const ModalProvider = ({ children }) => {
    const contextValue = useReducer(reducer, initialState);
    const modals = contextValue[0];
    return (
        <ModalContext.Provider value={contextValue}>
            {children}
            {modals && modals.map((modal) => {
                return (
                    <div key={modal.id}>
                        {React.cloneElement(modal.modal, {modalId: modal.id })}
                    </div>
                );
            })}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const a = useContext(ModalContext);
    return {
        modals: a[0],
        openModal: a[1],
        closeModal: a[1],
    };
};
